import React, { useContext } from "react"
import { AdminContext } from "@/contexts/AdminContext"
import PriceModeSelector from "./components/PriceModeSelector"
import PricingTable from "./components/table"
import useSearchParams from "~/hooks/useSearchParams"
import { useMe } from "~/api2/hooks/useMe"

const PricesForm = () => {
  const { data: user } = useMe()
  //TODO: this flow was simplified while the rv prices are not done
  //const isParkAdminUser = user?.email?.includes("@poweredbypark.com") || false
  //const searchParams = useSearchParams()
  //const selectedTab = searchParams.get("s")
  return (
    <div className="flex-col w-full">
      <PriceModeSelector />
      {/* {selectedTab === "pricing_general" && <PriceModeSelector />} */}

      {/* 
      TODO: disabling the rv parks until they are not broken
      {isParkAdminUser && selectedTab.startsWith("pricing_") && selectedTab !== "pricing_general" && <PricingTable />} */}
    </div>
  )
}

export default PricesForm
